module.exports = __webpack_public_path__ + "static/home-fighter-jet-702a1262647ed5f6403d584b407349f0.jpg";